"use client";
import { useGlobalLoader } from "@/context/LoaderContext";
import { useEffect, useState } from "react";

export default function GlobalLoader() {
  const { isLoading } = useGlobalLoader();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let interval;
    let timeout;

    if (isLoading) {
      setProgress(0);
      setVisible(true);

      // Quickly jump to ~30%, then slow down, simulating real load
      interval = setInterval(() => {
        setProgress((prev) => {
          if (prev < 30) return prev + 5;
          if (prev < 60) return prev + 2;
          if (prev < 85) return prev + 0.5;
          return prev; // stall near 85% until done
        });
      }, 120);
    } else {
      clearInterval(interval);
      // Complete the bar when loading finishes
      setProgress(100);
      timeout = setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 500);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [isLoading]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-[3px]">
      <div
        className="h-full bg-amber-900 transition-all ease-out"
        style={{
          width: `${progress}%`,
          transitionDuration: progress === 100 ? "200ms" : "400ms",
          boxShadow: "0 0 8px rgba(120, 53, 15, 0.7), 0 0 2px rgba(120, 53, 15, 0.5)",
        }}
      />
    </div>
  );
}